import DotMenu from '@crossiety/lit-components/components/dot_menu/element.js';

Object.defineProperty(DotMenu.prototype, 'isSmallDevice', {
  get: function () {
    return window.innerWidth < 992;
  },
});
